import type { ChartDot } from './chart-data';

export type MarkingSide = 'BUY' | 'SELL';
// Named-point order for SELL and replacements; a new BUY assigns names after both clicks.
export const pointOrder = (side: MarkingSide) => side === 'BUY' ? [2, 1] as const : [1, 2] as const;
export const nextMarker = (side: MarkingSide | null, dots: ChartDot[]) => side
  ? pointOrder(side).find(number => !dots.some(dot => dot.number === number)) ?? null
  : null;
export const pointLocation = (side: MarkingSide, number: number) =>
  (side === 'BUY' ? number === 2 : number === 1) ? 'tertinggi' : 'terendah';
export function matchesDirection(side: MarkingSide | null, dots: ChartDot[]) {
  const z = dots.find(dot => dot.number === 1), p = dots.find(dot => dot.number === 2);
  return !side || !z || !p || (side === 'BUY' ? p.price > z.price : z.price > p.price);
}

// A new BUY records two chosen locations. Their relative prices, not click
// order, determine Z (low) and P (high). Existing-point edits stay strict.
export function arrangeBuyPoints(dots: ChartDot[], automatic: boolean): ChartDot[] {
  if (!automatic || dots.length !== 2 || dots[0].price === dots[1].price) return dots;
  const [low, high] = dots[0].price < dots[1].price ? dots : [dots[1], dots[0]];
  return [{ ...low, id: 'dot-1', number: 1 }, { ...high, id: 'dot-2', number: 2 }];
}
